import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, connect } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { IconMic } from '../../../base/icons/svg';
import ClickableIcon from '../../../base/ui/components/web/ClickableIcon';
import { muteAllParticipants } from '../../../video-menu/actions.any';
import { requestEnableAudioModeration, requestDisableAudioModeration, participantsMutedByHost } from '../../../av-moderation/actions';
import { MEDIA_TYPE } from '../../../base/media/constants';
import { isEnabledFromState } from '../../../av-moderation/functions';
const useStyles = makeStyles()(() => {
    return {
        isMutedButton: {
            '& .jitsi-icon': {
                '& svg': {
                    fill: "#00B2D2"
                }
            }
        }
    };
});
function MuteAllButton({ isAudioModerationEnabled }) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { classes: styles } = useStyles();
    const [isMuted, setIsMuted] = useState(false);
    const onInvite = useCallback(() => {
        const exclude = [''];
        setIsMuted(true);
        dispatch(muteAllParticipants(exclude, MEDIA_TYPE.AUDIO));
        dispatch(participantsMutedByHost(true));
        // isAudioModerationEnabled - allow attendees to unmute themselves 
        // this is enabled from state by default 
        if (isAudioModerationEnabled) {
            dispatch(requestEnableAudioModeration());
        }
        else if (isAudioModerationEnabled !== undefined) {
            dispatch(requestDisableAudioModeration());
        }
        setTimeout(() => {
            setIsMuted(false);
            //  dispatch(participantsMutedByHost(false));
        }, 5000);
    }, [dispatch]);
    return (React.createElement(ClickableIcon, { accessibilityLabel: t('participantsPane.actions.muteAll'), icon: IconMic, onClick: onInvite, className: isMuted ? styles.isMutedButton : '', toolTip: t('participantsPane.actions.muteAll'), tooltipPosition: 'bottom' }));
}
;
function _mapStateToProps(state) {
    const audioMod = isEnabledFromState(MEDIA_TYPE.AUDIO, state);
    return {
        isAudioModerationEnabled: isEnabledFromState(MEDIA_TYPE.AUDIO, state)
    };
}
export default connect(_mapStateToProps)(MuteAllButton);
